import React from "react";

const SvgCheck = props => (
  <svg
    viewBox="0 0 128 128"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    {...props}
  >
    <path d="M52.623 73.327l55.092-55.092 19.393 19.394-73.139 73.14-19.394-19.395L.892 57.691l18.047-18.048 33.684 33.684z" />
  </svg>
);

export default SvgCheck;
